<template>
  <div class="mt-8">
    <v-layout wrap>
      <v-flex>
        <!-- Snackbar untuk notifikasi -->
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <!-- Dialog Konfirmasi Final -->
        <v-dialog 
          v-model="dialog.finalConfirm"
          @keydown.esc="dialog.finalConfirm = false"
          width="600"
          persistent
          scrollable>
          <v-card class="border-radius-card">
            <v-card-title class="d-flex align-center pa-4 text-right popup-header">
              <div class="fs-20 font-weight-bold">
                Konfirmasi Final
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.finalConfirm = false"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <v-divider class="mb-2" style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text class="py-4 px-6 black--text">
              <div class="text-center">
                <v-icon 
                  size="64" 
                  color="red" 
                  class="mb-4">
                  mdi-alert-circle-outline
                </v-icon>
                
                <p class="fs-18 font-weight-bold mb-3" style="line-height: 1.5;">
                  Jiak SO Nomernya <strong>{{ bpbData.order_number || '' }}</strong> memiliki lebih dari 1 BPB, Anda yakin untuk hapus seluruh data BPB yang terkait dengan SO ini selain BPB <strong>{{ bpbData.bpb_number || '' }}</strong>?
                </p>
                
                <p class="fs-16 mb-4">
                  Tindakan ini tidak dapat dibatalkan dan akan menghapus semua data BPB terkait dengan nomor SO <strong>{{ bpbData.order_number || 'SO-202507-00948' }}</strong>
                </p>

                <!-- Error message -->
                <div v-if="message.error.length > 0" class="text-center mt-4">
                  <div class="error--text d-flex align-start justify-center">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    <span class="ml-1">{{ message.error }}</span>
                  </div>
                </div>
              </div>
            </v-card-text>
            
            <v-divider class="mt-2" style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions class="pa-4">
              <v-spacer/>

              <!-- Tombol Batal -->
              <v-btn
                @click="dialog.finalConfirm = false"
                :disabled="process.delete"
                width="120"
                height="45"
                outlined
                elevation="0"
                color="grey"
                class="fs-16 grey--text text-capitalize border-radius mr-3">
                Batal
              </v-btn>

              <!-- Tombol Ya, Hapus -->
              <v-btn
                @click="executeDelete()"
                :loading="process.delete"
                :disabled="process.delete"
                width="150"
                height="45"
                elevation="0"
                color="red"
                class="fs-16 white--text text-capitalize border-radius">
                Ya, Hapus
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Halaman Konfirmasi Hapus Data -->
        <section>
          <v-card 
            flat
            class="ma-4 mt-0 box-shadow pb-5"
            style="border-radius: 10px;">

            <!-- Header -->
            <v-row class="pa-4 py-0">
              <v-col cols="12">
                <div class="d-flex align-center">
                  <v-btn
                    @click="$router.go(-1)"
                    icon
                    color="#718EBF"
                    class="mr-3">
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                  <span class="fs-20 font-weight-bold black--text">
                    Konfirmasi Hapus Data
                  </span>
                </div>
              </v-col>
            </v-row>

            <v-divider class="mx-4" style="border-top: 2px dashed #e0e0e0;"/>

            <!-- Content -->
            <v-card-text class="py-6 px-6">
              <!-- Loading state -->
              <div v-if="process.load" class="text-center py-8">
                <div class="mb-4 title">
                  Memuat data...
                </div>
                <v-progress-linear
                  :color="set_color"
                  indeterminate
                  rounded
                  height="10">
                </v-progress-linear>
              </div>

              <!-- Content saat data sudah dimuat -->
              <div v-else>
                <!-- Teks konfirmasi -->
                <div class="mb-6 black--text">
                  <p class="fs-16 mb-4">
                    Anda ingin menghapus bpb dengan data berikut:
                  </p>
                  
                  <!-- Data BPB yang akan dihapus -->
                  <div class="mb-6">
                    <div class="d-flex align-center mb-3">
                      <span class="font-weight-bold mr-3 fs-16" style="width: 96px;">Nomor BPB</span>
                      <span class="fs-16">: {{ bpbData.bpb_number || 'BPB-202507-00990' }}</span>
                    </div>
                    <div class="d-flex align-center">
                      <span class="font-weight-bold mr-3 fs-16" style="width: 96px;">Nomor SO</span>
                      <span class="fs-16">: {{ bpbData.order_number || 'SO-202507-00948' }}</span>
                    </div>
                  </div>

                  <!-- Tabel data terkait -->
                  <div class="mb-6">
                    <p class="fs-16 mb-4">
                      Data terkait dengan Nomor SO <strong>{{ bpbData.order_number || 'SO-202507-00948' }}</strong>:
                    </p>
                    
                    <!-- Tabel dengan format spreadsheet -->
                    <div class="spreadsheet-table">
                      <table class="confirmation-table">
                        <thead>
                          <tr>
                            <th>Nomor BPB</th>
                            <th>Waktu input BPB</th>
                            <th>Nomor SO</th>
                            <th>Waktu Input SO</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in relatedData" :key="index">
                            <td>{{ item.bpb_number }}</td>
                            <td>{{ item.input_datetime | datetime }}</td>
                            <td>{{ item.order_number }}</td>
                            <td>{{ item.order_input_datetime | datetime }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Peringatan -->
                  <div class="mb-6">
                    <p class="fs-16">
                      Semua BPB terkait SO Nomor <strong>{{ bpbData.order_number || 'SO-202507-00948' }}</strong> akan dihapus
                    </p>
                  </div>

                  <!-- Pertanyaan konfirmasi -->
                  <div class="mb-6">
                    <p class="fs-16 font-weight-bold">
                      Anda yakin ingin menghapus data di atas?
                    </p>
                  </div>

                  <!-- Error message -->
                  <div v-if="message.error.length > 0" class="text-center mt-4 mb-4">
                    <div class="error--text d-flex align-start justify-center">
                      <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                      <span class="ml-1">{{ message.error }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
            
            <v-divider class="mx-4" style="border-top: 2px dashed #e0e0e0;"/>

            <!-- Action Buttons -->
            <v-card-actions class="pa-6">
              <v-spacer/>

              <!-- Tombol Tidak, Batal Hapus Data -->
              <v-btn
                @click="$router.go(-1)"
                :disabled="process.delete"
                width="250"
                height="45"
                outlined
                elevation="0"
                color="blue"
                class="fs-16 blue--text text-capitalize border-radius mr-3">
                Tidak, Batal Hapus Data
              </v-btn>

              <!-- Tombol Ya, Hapus Data -->
              <v-btn
                @click="confirmDelete()"
                :loading="process.delete"
                :disabled="process.delete"
                width="180"
                height="45"
                elevation="0"
                color="red"
                class="fs-16 white--text text-capitalize border-radius">
                Ya, Hapus Data
              </v-btn>
            </v-card-actions>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
import { get, post, put, patch, destroy } from "@/service/Axios";
import moment from "moment"
import "moment/locale/id"

export default {
  data() {
    return {
      dialog: {
        snackbar: false,
        finalConfirm: false
      },
      
      bpbData: {
        bpb_number: '',
        order_number: '',
        bpb_id: ''
      },
      
      relatedData: [
        {
          bpb_number: 'BPB-202507-00990',
          bpb_input_time: '2025-07-13 23:29:51',
          so_number: 'SO-202507-00948',
          so_input_time: '2025-07-12 11:35:21'
        },
        {
          bpb_number: 'BPB-202507-00991',
          bpb_input_time: '2025-07-13 23:29:51',
          so_number: 'SO-202507-00948',
          so_input_time: '2025-07-12 11:35:21'
        }
      ],

      process: {
        load: false,
        delete: false
      },
      
      message: {
        success: '',
        error: ''
      }
    }
  },
  
  computed: {
    set_color() {
      return this.$store.state.color
    }
  },
  
  mounted() {
    this.fetchBpbData()
  },
  
  methods: {
    async fetchBpbData() {
      this.process.load = true
      
      try {
        // Ambil data BPB berdasarkan ID dari route
        const bpbNumber = this.$route.params.id
        
        await get(`admin/delete_data/bpb/data_bpb_tanpa_sj?bpb_number=${bpbNumber}`)
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.bpbData = res.results.data[0]
            // this.relatedData = res.results.related_data || this.relatedData
            this.fetchRelatedData(this.bpbData.order_number)
          }
        })
      } catch (error) {
        console.error('Error fetching BPB data:', error)
        this.message.error = 'Gagal memuat data BPB'
      } finally {
        // this.process.load = false
      }
    },

    async fetchRelatedData(data_order_number) {
      this.process.load = true
      
      try {
        
        await get(`admin/delete_data/bpb/data_bpb_tanpa_sj?order_number=${data_order_number}`)
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.relatedData = res.results.data || this.relatedData
          }
        })
      } catch (error) {
        console.error('Error fetching BPB data:', error)
        this.message.error = 'Gagal memuat data BPB'
      } finally {
        this.process.load = false
      }
    },

    confirmDelete() {
      // Tampilkan dialog konfirmasi final
      this.dialog.finalConfirm = true
    },

    async executeDelete() {
      this.message.error = ''
      this.process.delete = true
      
      try {
        await post(`admin/delete_data/bpb/delete_bpb_tanpa_sj`, {
          data: {
            order_id: this.bpbData.order_id
          }
        }).then(response => {
          let res = response.data
          
          // this.process.delete = false
          
          if (res.status === 200) {
            this.dialog.finalConfirm = false
            this.dialog.snackbar = true
            this.message.success = res.message
            
            // Redirect ke halaman list setelah berhasil
            setTimeout(() => {
              this.$router.push('/hapus-data/bpb')
            }, 500)
          } else {
            this.message.error = res.message
          }
        })
      } catch (error) {
        this.process.delete = false
        this.message.error = 'Terjadi kesalahan saat menghapus data'
        console.error('Error deleting BPB:', error)
      }
    }
  }
}
</script>

<style scoped>
.spreadsheet-table {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  background: white;
}

.confirmation-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.confirmation-table th,
.confirmation-table td {
  border: 1px solid #e0e0e0;
  padding: 12px 16px;
  text-align: left;
  font-size: 14px;
}

.confirmation-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}

.confirmation-table tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.confirmation-table tbody tr:hover {
  background-color: #f0f0f0;
}

.border-radius-card {
  border-radius: 10px !important;
}

.popup-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.cursor-pointer {
  cursor: pointer;
}

.fs-20 {
  font-size: 20px !important;
}

.fs-16 {
  font-size: 16px !important;
}

.border-radius {
  border-radius: 8px !important;
}
</style>
